import { FirebaseApp, FirebaseOptions, initializeApp } from 'firebase/app'
import { Analytics, getAnalytics } from 'firebase/analytics'
import { Firestore, getFirestore } from 'firebase/firestore'


const config: FirebaseOptions = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
}


let firebaseApp: FirebaseApp
let analytics: Analytics  // eslint-disable-line no-unused-vars, @typescript-eslint/no-unused-vars
let fireStore: Firestore


/**
 * Firebase の利用を開始する
 */
export function initFirebase(): void {
  firebaseApp = initializeApp(config)
  analytics = getAnalytics(firebaseApp)  // eslint-disable-line no-unused-vars, @typescript-eslint/no-unused-vars
  fireStore = getFirestore(firebaseApp)
}


/**
 * Firestore インスタンスを得る
 */
export function useFireStore(): Firestore {
  return fireStore
}


